// Machine-authored for Phase 6c; requires review by a native Arabic speaker.
const validation = {
  required: "هذا الحقل مطلوب.",
  usernameRequired: "اسم المستخدم مطلوب.",
  passwordRequired: "كلمة المرور مطلوبة.",
  emailRequired: "البريد الإلكتروني مطلوب.",
  emailInvalid: "يُرجى إدخال بريد إلكتروني صحيح.",
  codeRequired: "رمز التحقق مطلوب.",
  codeLength: "يجب أن يتكون رمز التحقق من 6 أرقام.",
  codeNumeric: "يجب أن يحتوي رمز التحقق على أرقام فقط.",
  passwordMinLength: "كلمة المرور يجب أن تحتوي على 8 أحرف على الأقل.",
  passwordUppercase: "كلمة المرور يجب أن تحتوي على حرف كبير واحد على الأقل.",
  passwordLowercase: "كلمة المرور يجب أن تحتوي على حرف صغير واحد على الأقل.",
  passwordNumber: "كلمة المرور يجب أن تحتوي على رقم واحد على الأقل.",
  passwordSpecialChar: "كلمة المرور يجب أن تحتوي على رمز خاص واحد على الأقل.",
  passwordsDoNotMatch: "كلمتا المرور غير متطابقتين.",
  confirmPasswordRequired: "يُرجى تأكيد كلمة المرور.",
  usernameInvalid:
    "يجب أن يتكون اسم المستخدم من 3 إلى 30 حرفاً، ويحتوي على حروف وأرقام ونقاط وشرطات سفلية أو عادية فقط.",
  usernameStartLetter:
    "يجب أن يبدأ اسم المستخدم بحرف وأن يحتوي فقط على أحرف إنجليزية أو أرقام أو نقاط أو شرطات سفلية أو شرطات.",
  textMinLength: "يجب أن يحتوي هذا الحقل على 4 أحرف على الأقل.",
  textMaxLength: "يجب ألا يتجاوز هذا الحقل 50 حرفاً.",
  phoneRequired: "رقم الهاتف مطلوب.",
  phoneInvalid: "يُرجى إدخال رقم هاتف صحيح.",
  phoneLeadingZero: "يجب أن يبدأ رقم الهاتف المصري بصفر (مثال: 01012345678).",
  phoneEgyptLength: "يجب أن يتكون رقم الهاتف المصري من 11 رقمًا بالضبط.",
  phoneSaudiStart: "يجب أن يبدأ رقم الهاتف السعودي بالرقم 5 (مثال: 512345678).",
  phoneSaudiLength: "يجب أن يتكون رقم الهاتف السعودي من 9 أرقام بالضبط.",
  phoneLength: "يجب أن يحتوي رقم الهاتف على عدد أرقام صحيح للدولة المحددة.",
  nameMaxLength: "يجب ألا يتجاوز الاسم 255 حرفاً.",
  maxLength: "يجب ألا يتجاوز 255 حرفاً.",
  nameArabicOnly: "يجب أن يحتوي الاسم على حروف عربية فقط.",
  nameEnglishOnly: "يجب أن يحتوي الاسم على حروف إنجليزية فقط.",
  nameTrioRequired: "يجب أن يكون الاسم ثلاثياً.",
};

export default validation;
